// extracted by mini-css-extract-plugin
export var phone = "_2c-0";